export function useTRPC() {
  return useNuxtApp().$trpc
}
